import { render } from "./provident-fund.vue?vue&type=template&id=ba1bb3ec"
import script from "./provident-fund.vue?vue&type=script&lang=js"
export * from "./provident-fund.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__